var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-render-link"},[(_vm.params.value.withIcon)?_c('v-icon',{staticClass:"mr-4"},[_vm._v("mdi-web")]):_vm._e(),_c('a',{attrs:{"href":_vm.params.value.href,"target":_vm.target}},[_vm._v(_vm._s(_vm.params.value.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }